const buttonStyle = {
    border: "none",
    textAlign: "left",
    color: "#069",
    textDecoration: "underline",
    cursor: "pointer"
};

function MainComponent() {

    document.title = "NEC ファーストコンタクトセンターのサービス内容詳細| ファーストコンタクトセンター";
    const imageUrl = require("../../images/popup.png");

    const handleMouseEnter = (event) => {
        event.target.style.textDecoration = 'none';
    };

    const handleMouseLeave = (event) => {
        event.target.style.textDecoration = 'underline';
    };

    const handleClick = (el) => {
        const element = document.getElementById(el);
        const scrollingPosition = element.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: scrollingPosition, behavior: 'smooth' });
    };

    return (
        <>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="str-outer-wide">
                        <div className="str-inner">
                            <div className="mod-hdg-l1">
                                <div className="inner">
                                    <h1 className="hdg">Web問い合わせシステム</h1>
                                    <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                                </div>
                            </div>

                            <h2 className="mod-hdg-l2-02">
                                <span>NEC ファーストコンタクトセンターのサービス内容詳細</span>
                            </h2>

                            <div className="mod-txt">
                                <p>NEC ファーストコンタクトセンター（以下「当センター」）では、ビジネスPC、Express5800シリーズ、iStorageシリーズ、ソフトウェア製品を販売・サポートいただく際の疑問や問題を、早期解決出来るよう支援いたします。</p>
                                <p>当センターの支援範囲や免責事項など、お問い合わせ時にご注意いただきたい点を以下にまとめましたので、お問い合わせ前に必ずご確認の上、ご理解くださいますようお願いいたします。</p>
                            </div>

                            <h3 className="mod-hdg-l3-02">
                                <span>お問い合わせ対象商品</span>
                            </h3>

                            <div className="mod-txt">
                                <p>ビジネスPC(Mate/VersaPro)/Express5800販売支援サイト・iStorage支援サイトに掲載している以下の商品。</p>
                            </div>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>ビジネスPC(Mate，VersaPro，Chromebook)製品全般</p>
                                            <div className="mod-list-02 of-notice" style={{ marginBottom: "0px" }}>
                                                <ul className="list">
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    添付されている他社製のソフトウェアにつきましては、各ソフトウェアベンダにお問い合わせくださいますようお願いいたします。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    自社内で利用しているPCに関するお問い合わせは、担当窓口へご相談ください。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>Express5800シリーズ</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>iStorageシリーズ</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>Express5800シリーズ(UL/UW型番)/iStorageシリーズ(UF型番)用ソフトウェア</p>
                                            <div className="mod-list-02 of-notice" style={{ marginBottom: "0px" }}>
                                                <ul className="list">
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    UL型番などのソフトウェア製品は、ご購入済みであれば、 <img src={imageUrl} alt="popup" className="icn" lang="en" /><a href="https://www.support.nec.co.jp/PSHome.aspx" target="_blank" rel="noreferrer">サポートポータル</a> からサポート窓口(有償)へお問い合わせください。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    ソフトウェア製品につきましては、製品部門の窓口を紹介させていただく場合があります。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    Windows、ARCServe等のOEM製品におきまして、他ベンダから購入される場合(UL型番の製品ではない場合)は、ご購入元にお問い合わせください。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* --お問い合わせ対象商品 */}


                            <h3 className="mod-hdg-l3-02">
                                <span>お問い合わせにあたってのご注意・お願い</span>
                            </h3>

                            <div className="mod-txt">
                                <p>お問い合わせいただきましたご質問や当センターからの回答に関し、お互いの認識の違いなどに起因して、トラブルが発生する場合もあります。</p>
                                <p>そのようなトラブルにおきましては、状況によっては、当センターで責任を負いかねる場合もあります。以下の注意事項をご一読いただき、ご理解いただいたうえでお問い合わせくださいますようお願いいたします。</p>
                            </div>

                            <div className="mod-list" style={{ marginLeft: "30px" }}>
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <button
                                                style={buttonStyle}
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={() => { handleClick("general-inquiries") }}
                                            >お問い合わせ全般について</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <button
                                                style={buttonStyle}
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={() => { handleClick("about-configuration") }}>構成・接続に関するお問い合わせについて</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <button
                                                style={buttonStyle}
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={() => { handleClick("about-offer-price") }}>提供価格・仕切価格・納期および各種制度に関するお問い合わせについて</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <button
                                                style={buttonStyle}
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={() => { handleClick("about-services") }}>有償サービスの範囲に該当するお問い合わせについて</button>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <button
                                                style={buttonStyle}
                                                onMouseEnter={handleMouseEnter}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={() => { handleClick("about-failures") }}>障害・トラブルに関するお問い合わせについて</button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/*--お問い合わせにあたってのご注意・お願い  */}


                            <h3 className="mod-hdg-l3-02" id="general-inquiries">
                                <span>お問い合わせ全般について</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>お問い合わせで記載いただいたお客様の個人情報や相談内容は、厳重に取り扱います。当センターでは、個人番号(マイナンバー)が含まれない情報の範囲で対応いたします。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターから回答した内容および回答の際に添付する資料は、お問い合わせ者個人宛にお送りするものです。当センターからのe-mailでの回答を、そのまま転用することはご遠慮ください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>お客様への直接対応や、お客様向けの報告書・証明書等の作成に関するご依頼は、ご対応いたしかねます。当センターからの回答をもとにお問い合わせ元にてご対応願います。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターでは一両日中に回答するよう努めておりますが、他部門への確認など調査に時間がかかる、お問い合わせの際にご登録いただいた情報（e-mail/電話番号）が異なる、システム障害により回答が遅れる(できない)場合がございます。返答のない場合は、その旨お問い合わせください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>短納期（当日中等）のお問い合わせにつきましては、内容や受付状況などにより、ご要望にお応えしかねる場合もありますが、ご了承願います。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>カタログ、システム構成ガイド、製品通知、マニュアル等の各種資料に記載されていない内容など、製品開発部門に確認が必要なお問い合わせにつきましては、回答にお時間を要する場合がございます。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターでは、電話およびe-mailによる回答にて対応を行っております。ご提案時のお客様への同行や障害時の現地対応などは行っておりませんので、営業窓口 (もしくは該当部門)  までご相談ください。</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* --お問合せ全般について */}


                            <h3 className="mod-hdg-l3-02" id="about-configuration">
                                <span>構成・接続に関するお問い合わせについて</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>構成確認をご依頼の際は、お客様要件・システム要件の内容を必ず添えてください。要求仕様への適合確認や推奨モデルのアドバイスなどのご支援は行っていますが、構成作成は承っておりません。ご了承願います。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターからの回答内容につきましては、「製品通知」や「システム構成ガイド」などの内容と照合いただき、お問い合わせ元にて必ず最終の確認を行ってください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>他社製品との接続や動作に関するお問い合わせにつきましては、持ち合わせている情報の範囲内で回答をいたしますが、責任は負いかねます。お問い合わせ元にて、最終判断願います。</p>
                                        </div>
                                    </li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                            {/* --構成・接続に関するお問い合わせについて */}


                            <h3 className="mod-hdg-l3-02" id="about-offer-price">
                                <span>提供価格・仕切価格・納期および各種制度に関するお問い合わせについて</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>お客様への提供価格や導入費用の見積り・仕切価格・納期など営業的な内容、及び販売制度・保守制度に関するご質問は、発注先（または担当部門）までお問い合わせをお願いいたします。</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* --提供価格・仕切価格・納期および各種制度に関するお問い合わせについて */}


                            <h3 className="mod-hdg-l3-02" id="about-services">
                                <span>有償サービスの範囲に該当するお問い合わせについて</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>ビジネスPC，Express5800シリーズ，iStorageシリーズでは各種の有償サービス(ハードウェア/OS/ソフトウェア保守サービス，SI構築/コンサルティングサービスなど)を展開しております。有償サービスの範囲のお問い合わせにつきましては、各窓口をご利用ください。</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* --有償サービスの範囲に該当するお問い合わせについて */}


                            <h3 className="mod-hdg-l3-02" id="about-failures">
                                <span>障害・トラブルに関するお問い合わせについて</span>
                            </h3>

                            <div className="mod-list">
                                <ul className="list">
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターでは、発生箇所・発生要因に関する切り分け調査の支援と、既知の不具合か否かの切り分け調査の支援を行います。詳細な調査/解析(メモリダンプの解析など)および具体的な解決にあたっては、各種有償サービスをご利用くださいますようお願いいたします。</p>
                                            <div className="mod-list-02 of-notice" style={{ marginBottom: "0px" }}>
                                                <ul className="list">
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    切り分け調査をスムーズに行うため、お問い合わせの際はご利用されているシステム情報(製品型番/サービスパック/パッチ情報など)を一緒にご提供くださいますようお願いいたします。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    ソフトウェア製品の購入後のお問い合わせ(製品の操作・設定、障害対応など)は承っておりません。ご契約のPPサポートサービスにお問い合わせください。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    iStorageシリーズ（NS除く）のハードウェア障害・トラブルにつきまして、ご契約頂いている保守サービス会社にご相談ください。詳細な調査・解析及び、具体的な解決にあたっては、各種有償サービスをご利用ください。当窓口では、マニュアル等に記載の一般的な仕様の範囲で参考コメントいたします。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <span className="mark">※</span>
                                                        <div className="content">
                                                            <div className="mod-txt">
                                                                <p>
                                                                    ビジネスPC製品におきましては、既知の不具合に該当しない場合、営業経由での障害調査を依頼させていただくことがありますので、ご協力の程よろしくお願いいたします。
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>当センターでは、電話およびe-mailによる回答にて対応を行っております。現地対応などは行っておりませんので、ご了承ください。</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="mod-txt">
                                            <p>他社製品やお客様・パートナー様にて開発されたアプリケーションなど、前述の《お問い合わせ対象商品》以外に起因した障害・トラブルにつきましては、当センターではご対応いたしかねます。予めご了承ください。</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* --障害・トラブルに関するお問い合わせについて */}

                            <div className="mod-btn of-no-arrow">
                                <div className="btn">
                                    <button onClick={() => { window.close() }}>
                                        閉じる
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main >
        </>
    )
}

export default MainComponent;